// Edition + branding, resolved at build time from Vite env vars.
//
// EDITION is baked into the bundle: the SaaS build (default) ships the full
// storefront (landing, pricing, billing, GitHub sign-in, mail). The
// self-hosted build strips those and reads its brand identity from env so a
// partner can run the platform as their own product.

export type Edition = 'saas' | 'selfhosted'

export const EDITION: Edition =
  (import.meta.env.VITE_EDITION as Edition) === 'selfhosted' ? 'selfhosted' : 'saas'

export const isSelfHosted = EDITION === 'selfhosted'

// Mail add-on. The mail stack (Postfix/Dovecot/OpenDKIM/Rspamd) is paused and
// its containers are not running, so every mail screen stays hidden in BOTH
// editions — this is deliberately independent of EDITION. Set
// VITE_MAIL_ENABLED=true to bring the UI back once the stack runs again.
export const mailEnabled = (import.meta.env.VITE_MAIL_ENABLED as string) === 'true'

export const branding = {
  appName: (import.meta.env.VITE_APP_NAME as string) || 'Provisyer',
  // Accent color. Exposed as the --brand-primary CSS variable at boot for
  // inline-styled elements; the compiled Tailwind `brand` palette is not
  // recolored (see applyBranding).
  primaryColor: (import.meta.env.VITE_PRIMARY_COLOR as string) || '#0284c7',
  logoUrl: (import.meta.env.VITE_LOGO_URL as string) || '',
  faviconUrl: (import.meta.env.VITE_FAVICON_URL as string) || '',
  supportEmail: (import.meta.env.VITE_SUPPORT_EMAIL as string) || '',
  // Public IP customers point their domain's A record at (docs DNS guide).
  // The SaaS default is the Provisyer server; a self-hosted build leaves it
  // empty unless SERVER_IP is set, so it never advertises our IP.
  serverIp: (import.meta.env.VITE_SERVER_IP as string) || (isSelfHosted ? '' : '178.210.161.184'),
}

// Apply brand identity to the document. Called once at boot. In the SaaS
// build every value is the Provisyer default, so this is a no-op in practice.
export function applyBranding() {
  if (typeof document === 'undefined') return

  document.documentElement.style.setProperty('--brand-primary', branding.primaryColor)

  if (isSelfHosted) {
    document.title = branding.appName

    if (branding.faviconUrl) {
      let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.head.appendChild(link)
      }
      link.href = branding.faviconUrl
    }
  }
}
